import React, { Component } from 'react'
import { imageAddress } from '../../../utils/useful'

// export default function AsideBlog({ ads }) {
export default class AsideBlog extends Component {
    // const aside = [
    //     { srcaside: '/images/asideimgblog.svg' }
    // ] 
    render() {
        return (
            <div className='position-relative'>
                <section className='mrd-4 mb-5' >
                    <div>
                        <h3 className='text-small fw-600 '>Sit euismod tortor aliquet amet.</h3>
                        <p className='text-smaller color-muted my-2'>Commodo, ut tellus duis volutpat feugiat aliquam malesuada quis. Est placerat ultrices elementum</p>
                        <div>
                            {this.props.ads?.map((item, index) => {
                                return (
                                    // <div className="col-6 col-md-4 col-lg-3 mb-4 ">
                                    <div className='w-100 mb-2'>
                                        <div className="outline-none flex-1 h-100 br-10 prd-4" style={{ overflow: 'hidden' }}>
                                            <a className='w-100 h-100' href={item?.link}>
                                                {/* <img src={imageAddress(item.picture, null, 'thumb')} className="w-100 slidershop-img" style={{ flex: 1, height: '100%', objectFit: 'cover' }} /> */}
                                                <img src={item.src} className="w-100 br-10" style={{ flex: 1, height: '100%', objectFit: 'cover' }} />
                                            </a>
                                        </div>
                                    </div>
                                )
                            }
                            )}
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}
